import { email, required } from 'vuelidate/lib/validators'
import { passesApiValidation } from '@/plugins/vuelidate/validators'

export const validations = {
  email: {
    required,
    email,
    passesApiValidation: passesApiValidation('email')
  }
}

export const messages = {
  email: {
    required: 'Required',
    email: 'Must be a valid email address',
  }
}